import { render, staticRenderFns } from "./LocationTable.vue?vue&type=template&id=223debfd"
import script from "./LocationTable.vue?vue&type=script&lang=js"
export * from "./LocationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports